import Parse from 'html-react-parser';

function BMP20159(props) {
    let svgCode =
        `<svg width="544" height="504" viewBox="0 0 544 504" fill="none" xmlns="http://www.w3.org/2000/svg">
        <style type="text/css">
        .styledText text {
            ${props.styledText}
        }
        .radiation {
            ${props.radiation}
        }
        ${props.fontFace}
        </style>
        <g class="styledText" font-weight="${props.fontExtras.weight}" letter-spacing="${props.fontExtras.space}">
        <rect width="544" height="504" fill="none"/>
        <rect x="138" y="126" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.highlightColour}" font-family="${props.fontName}" font-size="26"><tspan x="187" y="227.887">FX</tspan></text>
        <circle class="radiation" cx="204" cy="160" r="6.5" fill="${props.highlightColour}" stroke="black" stroke-width="3"/>
        <rect x="138" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="187" y="101.887">FX</tspan></text>
        <circle cx="204" cy="34" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="138" y="252" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="187" y="353.887">FX</tspan></text>
        <circle cx="204" cy="286" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="138" y="378" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="187" y="479.887">FX</tspan></text>
        <circle cx="204" cy="412" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="274" y="126" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="291" y="227.887">MATRIX</tspan></text>
        <circle cx="340" cy="160" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="274" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="291" y="101.887">MATRIX</tspan></text>
        <circle cx="340" cy="34" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="274" y="252" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.highlightColour}" font-family="${props.fontName}" font-size="26"><tspan x="291" y="353.887">MATRIX</tspan></text>
        <circle class="radiation" cx="340" cy="286" r="6.5" fill="${props.highlightColour}" stroke="black" stroke-width="3"/>
        <rect x="274" y="378" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="291" y="479.887">MATRIX</tspan></text>
        <circle cx="340" cy="412" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="410" y="126" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="430" y="227.887">GLOBAL</tspan></text>
        <circle cx="476" cy="160" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="410" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="430" y="101.887">GLOBAL</tspan></text>
        <circle cx="476" cy="34" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="410" y="252" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="430" y="353.887">GLOBAL</tspan></text>
        <circle cx="476" cy="286" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="410" y="378" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.highlightColour}" font-family="${props.fontName}" font-size="26"><tspan x="430" y="479.887">GLOBAL</tspan></text>
        <circle class="radiation" cx="476" cy="412" r="6.5" fill="${props.highlightColour}" stroke="black" stroke-width="3"/>
        <rect x="2" y="126" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="42" y="227.887">OSC</tspan></text>
        <circle cx="68" cy="160" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="2" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.highlightColour}" font-family="${props.fontName}" font-size="26"><tspan x="42" y="101.887">OSC</tspan></text>
        <circle class="radiation" cx="68" cy="34" r="6.5" fill="${props.highlightColour}" stroke="black" stroke-width="3"/>
        <rect x="2" y="252" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="42" y="353.887">OSC</tspan></text>
        <circle cx="68" cy="286" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        <rect x="2" y="378" width="132" height="122" fill="${props.backgroundFill}"/>
        <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="42" y="479.887">OSC</tspan></text>
        <circle cx="68" cy="412" r="6.5" fill="${props.backgroundFill}" stroke="black" stroke-width="3"/>
        </g>
    </svg>`

    props.svgReturn(7, svgCode, "bmp00159", 544, 504)

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "121px",
        top: "0",
        left: "306px",
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20159;